// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dOC1q","field":"styles_field__1RHDO","fieldCol":"styles_fieldCol__2VejL","diffCol":"styles_diffCol__2Wfi7","diff":"styles_diff__HHPb9"};